module.exports = __webpack_public_path__ + "static/media/icici.c6fb0f64.svg";